export default {

  /**
   * @param targetPeriodId
   * @param currentPeriodId
   * @param existingPrice
   * @param newPrice
   * @returns {*}
   */
  takeNewOrExistingPrice(targetPeriodId, currentPeriodId, existingPrice, newPrice) {
    if (this.samePeriod(targetPeriodId, currentPeriodId)
      && (
        (
          this.samePersonCategoryForPrice(existingPrice, newPrice)
          && this.sameDayNumberForPrice(existingPrice, newPrice)
        )
        || (
          !this.isPriceCreated(existingPrice)
          && this.isPriceMissingPersonCategory(existingPrice)
          && this.sameDayNumberForPrice(existingPrice, newPrice)
        )
      )
    ) {
      return newPrice;
    }
    return existingPrice;
  },

  /**
   * @param currentPeriodId
   * @param targetPeriodId
   * @param prices
   * @param newPrice
   * @returns {*|boolean}
   */
  shouldAddPriceItemToPrices(currentPeriodId, targetPeriodId, prices, newPrice) {
    return !this.isPriceCreated(newPrice)
      && this.samePeriod(currentPeriodId, targetPeriodId)
      && (
        this.checkAllPricesInPeriodIsNotCreated(prices, newPrice)
        || this.checkSomePricesInPeriodIsCreated(prices, newPrice)
      );
  },

  /**
   * @param currentPeriodId
   * @param targetPeriodId
   * @param prices
   * @param newPrice
   * @returns {boolean|*}
   */
  shouldAddNewUnknownPriceItemToPrices(currentPeriodId, targetPeriodId, prices, newPrice) {
    return !this.isPriceCreated(newPrice)
      && this.isPriceMissingPersonCategory(newPrice)
      && this.samePeriod(currentPeriodId, targetPeriodId)
      && (
        this.checkSomePricesInPeriodHasPersonCategory(prices)
        || this.noPricesExists(prices)
      );
  },

  /**
   * @param prices
   * @param newPrice
   * @returns {boolean|*}
   */
  checkAllPricesInPeriodIsNotCreated(prices, newPrice) {
    return prices.every(existingPrice =>
      !this.isPriceCreated(existingPrice)
      && this.sameDayNumberForPrice(existingPrice, newPrice)
      && this.isPriceMissingPersonCategory(existingPrice),
    );
  },

  /**
   * @param prices
   * @param newPrice
   * @returns {boolean|*}
   */
  checkSomePricesInPeriodIsCreated(prices, newPrice) {
    return prices.some(existingPrice =>
      this.isPriceCreated(existingPrice)
      && this.sameDayNumberForPrice(existingPrice, newPrice)
      && !this.samePersonCategoryForPrice(existingPrice, newPrice),
    );
  },

  /**
   * @param prices
   * @returns {boolean|*}
   */
  checkSomePricesInPeriodHasPersonCategory(prices) {
    return prices.some(existingPrice => existingPrice.skiPassPersonCategoryId !== undefined);
  },

  /**
   * @returns {boolean}
   */
  noPricesExists(prices) {
    return prices.length === 0;
  },

  /**
   * @param periodId
   * @param targetPeriodId
   * @returns {boolean}
   */
  samePeriod(periodId, targetPeriodId) {
    return periodId === targetPeriodId;
  },

  /**
   * @param existingPrice
   * @param newPrice
   * @returns {boolean}
   */
  sameDayNumberForPrice(existingPrice, newPrice) {
    return existingPrice.days === newPrice.days;
  },

  /**
   * @param existingPrice
   * @param newPrice
   * @returns {boolean}
   */
  samePersonCategoryForPrice(existingPrice, newPrice) {
    return existingPrice.skiPassPersonCategoryId === newPrice.skiPassPersonCategoryId;
  },

  /**
   * @param price
   * @returns {boolean}
   */
  isPriceCreated(price) {
    return price.id !== undefined;
  },

  /**
   * @param price
   * @returns {boolean}
   */
  isPriceMissingPersonCategory(price) {
    return price.skiPassPersonCategoryId === undefined;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/skipass/periodPriceHelper.js